import HeroCarousel from "../components/home/HeroCarousel";
import ServicesSection from "../components/home/ServicesSection";
import TournamentsSection from "../components/home/TournamentsSection";
import LocationSection from "../components/home/LocationSection";
import FeaturedProductSection from "../components/home/FeaturedProductSection";
import CardOfTheDay from "../components/home/CardOfTheDay";
import StatsSection from "../components/home/StatsSection";

const HomePage = () => {
  return (
    <>
      <HeroCarousel />
      <StatsSection />
      <FeaturedProductSection />
      <CardOfTheDay />
      <ServicesSection />
      <TournamentsSection />
      <LocationSection />
    </>
  );
};

export default HomePage;
